function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require('react');

var _ = require('lodash');

var Tooltip = require('../tooltip');

var InputValidationErrorSymbol = require('../inputValidationError.svg.js');

var InputValidationSuccessSymbol = require('../inputValidationSuccess.svg.js');

var TextLabel = require('../textLabel');

var _require = require('./constants'),
    dataHooks = _require.dataHooks;

module.exports = function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName(this.getRootCssClasses()),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    onClick: this.props.onClick
  }, this.props.prefix ? /*#__PURE__*/React.createElement("label", {
    htmlFor: this.uniqueId,
    key: "inputPrefix",
    className: 'input-prefix' + (this.props.focusOnPrefixClick ? ' clickable' : '')
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: this.props.prefix,
    shouldTranslate: this.props.shouldTranslate
  })) : null, this.refs.input && this.props.showInfoTooltip ? /*#__PURE__*/React.createElement(Tooltip, _.assign({}, {
    key: 'input-info',
    className: 'input-info',
    customTrigger: this.refs.input
  }, this.props.infoTooltipProps)) : null, /*#__PURE__*/React.createElement("input", _extends({}, this.getInputProps(), {
    "data-hook": dataHooks.TextInputTag
  })), this.props.inputTextSuffix ? /*#__PURE__*/React.createElement("span", {
    className: "input-text-suffix",
    key: "inputTextSuffix",
    "data-hook": dataHooks.inputTextSuffix
  }, this.props.inputTextSuffix) : null, this.props.invalidMessage ? /*#__PURE__*/React.createElement(Tooltip, {
    isOpen: this.props.tooltipIsOpen,
    content: this.props.invalidMessage,
    interactive: this.props.tooltipInteractive,
    shouldTranslate: _.isUndefined(this.props.shouldTranslateError) ? this.props.shouldTranslate : this.props.shouldTranslateError,
    alignment: this.props.tooltipAlignment,
    key: "validationErrorSymbol",
    className: "input-validation-icon"
  }, /*#__PURE__*/React.createElement("span", {
    "data-aid": "input-error-indication",
    "data-hook": dataHooks.errorIndication,
    className: "input-validation-icon-inner"
  }, /*#__PURE__*/React.createElement(InputValidationErrorSymbol, null))) : null, this.props.success ? /*#__PURE__*/React.createElement("span", {
    className: "input-validation-icon",
    key: "validationSuccessSymbol"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-validation-icon-inner"
  }, /*#__PURE__*/React.createElement(InputValidationSuccessSymbol, null))) : null);
};